import { useQuery } from "@tanstack/react-query";
import { tasks } from "../../lib/api";
import { Modal } from "../shared/Modal";

/**
 * The task's story: its whole life in plain text, the same text the Telegram
 * Story button posts. Origin, every round of checks and what failed, every
 * decision the operator made, how it ended, what it spawned, what it cost.
 */
export function StoryModal({ taskId, onClose }: { taskId: string; onClose: () => void }) {
  const story = useQuery({
    queryKey: ["story", taskId],
    queryFn: () => tasks.story(taskId),
  });
  return (
    <Modal size="lg" title="Story" onClose={onClose}>
      {story.data ? (
        <pre className="whitespace-pre-wrap break-words font-mono text-[12.5px] leading-relaxed text-text-primary">
          {story.data.text}
        </pre>
      ) : (
        <div className="py-8 text-center text-small text-text-tertiary">
          {story.isError ? "Could not load the story." : "Loading…"}
        </div>
      )}
    </Modal>
  );
}
